<template>
  <not-found-page></not-found-page>
</template>

<script setup>
import NotFoundPage from "@/modules/shared/views/NotFoundPage.vue";
</script>

<style scoped></style>
